"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditUser = void 0;
const asset_list_1 = require("client/components/asset-list");
const asset_list_overview_1 = require("client/components/asset-list-overview");
const change_password_modal_1 = require("client/components/change-password-modal");
const confirmation_modal_1 = require("client/components/confirmation-modal");
const icons_1 = require("client/components/icons");
const select_1 = require("client/components/material/select");
const text_area_1 = require("client/components/material/text-area");
const text_field_1 = require("client/components/material/text-field");
const modal_1 = require("client/components/modal");
const ui_1 = require("client/components/ui");
const callable_1 = require("client/components/ui/callable");
const multi_select_1 = require("client/components/ui/multi-select");
const iframe_preview_1 = require("client/modules/inventory-order/tabs/order-review/components/iframe-preview");
const store_1 = require("client/modules/patients/store");
const store_2 = require("client/modules/sites/modules/sites-detail/store");
const store_3 = require("client/modules/sites/modules/sites-list/store");
const store_4 = require("client/modules/users/modules/users-list/store");
const store_5 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const ramda_1 = require("ramda");
const React = require("react");
const react_1 = require("react");
const ReactTooltip = require("react-tooltip");
const util_1 = require("shared/util");
require("./edit-user.less");
const userImage = require("client/resources/users.svg");
const dummyUser = {
    email: "",
    prefix: "",
    firstName: "",
    groupId: 0,
    id: 0,
    image: "",
    lastName: "",
    suffix: "",
    notes: "",
    phone: "",
    phoneExt: "",
    password: "",
    confirmPassword: "",
    siteId: 0,
    sites: [],
    verification: "",
    verified: false
};
let EditUser = class EditUser extends react_1.Component {
    constructor() {
        super(...arguments);
        this.createUserMode = false;
        this.changePasswordModal = false;
        this.multiSelections = [];
        this.iframeUrl = "";
        this.showConfirmationEditUserSave = false;
        this.assetModal = false;
        // region React
        this.id = 0;
        // endregion
        this.renderUserAssetListRow = () => this.user.uploads && this.user.uploads.length
            ? this.user.uploads
                .sort((a, b) => moment(a.expDate) < moment(b.expDate) ? 1 : -1)
                .map((upload, index) => {
                let expdate = "";
                if (upload.expDate) {
                    expdate = moment(upload.expDate).format("MM/DD/YYYY");
                }
                return (React.createElement("li", { "data-tip": `${upload.fileOriginalName} ${upload.description ? " (" + upload.description + ")" : ""}
                    `, onClick: () => {
                        this.iframeUrl = upload.filePath;
                        this.currentAssetViewing = upload;
                    }, key: index, className: "list" },
                    React.createElement("div", { className: "list-expdate__name" }, upload.description || upload.fileOriginalName),
                    React.createElement("div", { className: "list-expdate__date" }, expdate ? ` ${expdate}` : "")));
            })
            : null;
        this.handleChangeHomepage = (value) => {
            this.user.homepage = value;
        };
        this.normalizeLabelHomepage = (key) => {
            const re = /([A-Z])/g;
            return key
                .replace("Homepage", "")
                .replace(re, " $1")
                .trim();
        };
        this.normalizeValueHomepage = (key) => {
            return key.replace("Homepage", "").trim();
        };
        this.handleHomepageInputChange = () => { };
        this.handleAssetsDescriptionsSave = async (uploads) => {
            await store_1.patientsStore.updateAssetsDescriptions(uploads);
            await store_4.usersListStore.loadUsers();
            if (store_2.sitesDetailStore.site.value) {
                store_2.sitesDetailStore.loadUsers({
                    id: store_2.sitesDetailStore.site.value.id
                });
            }
        };
        this.handleAssetsExpDateSave = async (uploads) => {
            await store_1.patientsStore.updateAssetsExpDate(uploads);
            await store_4.usersListStore.loadUsers();
        };
        this.handlePreviewClose = () => {
            this.iframeUrl = "";
            this.currentAssetViewing = null;
        };
        // endregion
        // region Event handlers
        this.handleChangeString = (fieldName) => (event, value) => {
            this.user[fieldName] = value;
            // console.log("pw: ", this.user.password);
            // console.log("conf: ", this.user.confirmPassword);
        };
        this.handleChangeMultiSelect = (values) => {
            this.multiSelections = values.map(e => e);
            this.user.sites = values.map(site => Number(site.value));
        };
        this.handleChangeGroup = (id) => {
            this.groupId = id;
            this.user.groupId = Number(this.groupId);
        };
        this.handleChangeSite = (id) => {
            if (this.siteId === id)
                return;
            const findOption = (siteId) => this.availableOptions.find((site) => site.value === siteId);
            const findSelection = (siteId) => this.multiSelections.find((site) => site.value === siteId);
            const oldOption = findOption(this.siteId);
            const newOption = findOption(id);
            const oldSelection = !!oldOption && findSelection(oldOption.value);
            const newSelection = findSelection(newOption.value);
            if (!!oldSelection) {
                this.multiSelections = this.multiSelections.filter(site => site.id !== oldSelection.id);
            }
            if (!newSelection)
                this.multiSelections.push(newOption);
            this.siteId = id;
            this.user.siteId = Number(this.siteId);
        };
        this.handleSelect = (fieldName) => (value) => {
            this.user[fieldName] = value;
        };
        this.isChanged = () => {
            const newUser = this.createUserMode;
            const diffSite = this.props.user && Number(this.siteId) !== this.props.user.siteId;
            const diffPass = this.user.password && this.user.password !== this.user.confirmPassword;
            const diffGroup = this.props.user && Number(this.groupId) !== this.props.user.groupId;
            const diffSites = !newUser &&
                (!!this.user.sites.length && !!this.props.user.sites.length
                    ? !ramda_1.equals(this.props.user.sites.map(site => site.id).sort(), this.user.sites.map(site => site.id).sort())
                    : !ramda_1.equals(this.user.site, this.user.site));
            const result = ramda_1.difference(Object.entries(ramda_1.omit(["site", "sites", "group", "admin"], this.user)), Object.entries(ramda_1.merge(dummyUser, this.props.user)));
            const changed = diffSite || diffSites || diffPass || diffGroup || result.length > 0;
            return changed;
        };
        this.isValid = (user) => Boolean(user.email &&
            (user.id || user.password) &&
            user.firstName &&
            user.lastName &&
            user.siteId &&
            user.groupId);
        this.handleSubmit = () => {
            // this.missing = {
            //   email: !this.user.email,
            //   password: !this.user.password,
            //   confirmPassword: !this.user.confirmPassword,
            //   firstName: !this.user.firstName,
            //   lastName: !this.user.lastName,
            //   siteId: !this.user.siteId,
            //   groupId: !this.user.groupId,
            // };
            if (this.siteId) {
                const id = Number(this.siteId);
                this.user.siteId = id;
            }
            if (this.groupId) {
                const id = Number(this.groupId);
                this.user.groupId = id;
            }
            if (this.multiSelections) {
                const allSites = store_3.sitesListStore.sites.value;
                const newSites = this.multiSelections.map(site => Number(site.value));
                this.user.sites = allSites.filter(site => newSites.includes(site.id));
            }
            // Need to remove Password and confirm password if we are not creating a NEW User
            if (!this.createUserMode) {
                // removes fields from this.user
                delete this.user.password;
                delete this.user.confirmPassword;
            }
            this.user.email = this.user.email.replace(/ /g, "");
            if (!this.isValid(this.user)) {
                this.missing = {
                    email: !this.user.email,
                    password: !this.user.id && !this.user.password,
                    confirmPassword: this.user.password && !this.user.confirmPassword,
                    firstName: !this.user.firstName,
                    lastName: !this.user.lastName,
                    siteId: !this.user.siteId,
                    groupId: !this.user.groupId
                };
            }
            else {
                callable_1.callable(this.props.onSave)(this.user);
            }
        };
        this.passwordConfirm = async (password) => {
            await store_4.usersListStore.changePassword(this.props.userId, password);
            this.handleChangePassword();
        };
        this.handleCancel = () => {
            this.props.onCancel();
        };
        this.handelDelete = () => {
            callable_1.callable(this.props.onDelete)(this.user);
        };
        this.handleChangePassword = () => {
            this.changePasswordModal = !this.changePasswordModal;
        };
        this.viewUserAssets = () => {
            this.assetModal = !this.assetModal;
        };
    }
    get availableOptions() {
        return store_3.sitesListStore.sites.value
            ? store_3.sitesListStore.sites.value.map((site, i) => ({
                id: i,
                label: site.displayName || site.name,
                value: site.id.toString()
            }))
            : [];
    }
    get availableGroups() {
        // console.log(usersListStore.groups);
        return store_4.usersListStore.groups.value
            ? store_4.usersListStore.groups.value.map((group, i) => ({
                id: i,
                label: group.name[0].toUpperCase() + group.name.slice(1),
                value: group.id.toString()
            }))
            : [];
    }
    componentWillMount() {
        // #TK condition to check if in user creation mode to display password field.
        // This implementation is dependent on the fact that a path of /0 is user creation mode.
        if (typeof window.location.pathname === "string") {
            this.createUserMode = window.location.pathname.split("/").pop() === "0";
        }
        this.user = ramda_1.merge(dummyUser, this.props.user);
        // sitesListStore.loadSites();
        store_3.sitesListStore.loadSitesNoRelation();
        store_4.usersListStore.loadGroups();
        this.siteId = (this.user.siteId && this.user.siteId.toString()) || "0";
        this.groupId = (this.user.groupId && this.user.groupId.toString()) || "0";
        this.missing = {
            email: false,
            password: false,
            confirmPassword: false,
            firstName: false,
            lastName: false,
            siteId: false,
            groupId: false
        };
    }
    componentWillReceiveProps(props) {
        if (props.user) {
            this.user = ramda_1.merge(dummyUser, props.user);
            this.siteId = (this.user.siteId && this.user.siteId.toString()) || "0";
            this.groupId = (this.user.groupId && this.user.groupId.toString()) || "0";
            store_4.usersListStore.loadGroups();
        }
    }
    componentDidMount() {
        const userSites = this.user.sites.map(site => site.id);
        this.multiSelections =
            this.availableOptions.filter(site => {
                const id = Number(site.value);
                return userSites.includes(id);
            }) || [];
    }
    render() {
        const user = this.user || dummyUser;
        const disableHighlightedFields = true;
        // C-094.1
        const getNumber = this.user.phone.slice(0, 14); // C-094.12
        let DataVal;
        let isError;
        if (getNumber.length) {
            DataVal = getNumber.replace(/\D+/g, "")
                .replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
            if (DataVal) {
                if (DataVal.length != 14) {
                    isError = "The information input currently is invalid";
                }
                else {
                    isError = "";
                }
            }
        }
        // Connor. Took out save button, they only want user editing going on from portal side.
        // DS - Took out Cancel button too, to not confuse user
        const buttons = [];
        //   <MaterialButton className="btnCancel" onClick={this.handleCancel}>
        //     Cancel
        //   </MaterialButton>,
        //   // "Save"
        // ];
        // if (!this.createUserMode) {
        //   buttons.unshift(
        //     <MaterialButton
        //       className="btnCancel"
        //       onClick={this.handleChangePassword}
        //     >
        //       Change Password
        //     </MaterialButton>
        //   );
        // }
        // const canEdit = usersStore.permissions.UpdateUser;
        return (React.createElement("div", { className: "edit-user" },
            React.createElement("a", { className: "close-button", onClick: this.handleCancel },
                React.createElement(icons_1.CloseIcon, null)),
            React.createElement("div", { className: "main" },
                React.createElement("div", { className: "main-left" },
                    React.createElement("div", { className: "user-avatar" },
                        React.createElement("div", { className: "user-image" },
                            React.createElement("img", { src: userImage })),
                        React.createElement("h3", null,
                            user.prefix,
                            " ",
                            user.firstName,
                            " ",
                            user.lastName,
                            " ",
                            user.suffix),
                        React.createElement("div", { className: "view-assets-remove-user" },
                            !this.createUserMode &&
                                store_5.usersStore.permissions.ReadUserAssets ? (React.createElement(asset_list_overview_1.AssetListOverview, { btnLabel: "Edit Asset", onClick: this.viewUserAssets }, this.renderUserAssetListRow())) : null,
                            this.props.onDelete && store_5.usersStore.permissions.DestroyUser && (React.createElement("div", { className: "user-remove" },
                                React.createElement(icons_1.DeleteIcon, null),
                                React.createElement("div", null,
                                    React.createElement("a", { onClick: this.handelDelete, href: "#" }, "REMOVE USER"))))))),
                React.createElement("div", { className: "user-info" },
                    React.createElement(ui_1.UiForm, { buttons: buttons, onSubmit: this.handleSubmit, 
                        // onSubmit={() => (this.showConfirmationEditUserSave = true)}
                        loading: this.props.loading, isChanged: this.isChanged, status: this.props.status ? this.props.status : ui_1.FormStatus.Clean, saved: "Saved", error: this.props.error },
                        React.createElement("div", { className: "row" },
                            React.createElement(text_field_1.MaterialTextField, { autoFocus: this.props.autoFocusForm, className: "firstName", label: "Prefix", disabled: true, 
                                // missing={this.missing.firstName}
                                onChange: this.handleChangeString("prefix"), value: `${user.prefix}` || "" }),
                            React.createElement(text_field_1.MaterialTextField, { autoFocus: this.props.autoFocusForm, className: "firstName", label: "First Name *", disabled: true, missing: this.missing.firstName, onChange: this.handleChangeString("firstName"), value: `${user.firstName}` || "" }),
                            React.createElement(text_field_1.MaterialTextField, { className: "lastName", label: "Last Name *", disabled: true, missing: this.missing.lastName, onChange: this.handleChangeString("lastName"), value: `${user.lastName}` || "" }),
                            React.createElement(text_field_1.MaterialTextField, { className: "lastName", label: "Suffix", disabled: true, 
                                // missing={this.missing.lastName}
                                onChange: this.handleChangeString("suffix"), value: `${user.suffix}` || "" })),
                        React.createElement("div", { className: "row" },
                            React.createElement(text_field_1.MaterialTextField, { className: "email", label: "Email *", disabled: true, missing: this.missing.email, onChange: this.handleChangeString("email"), value: user.email || "" }),
                            React.createElement(select_1.MaterialSelect, { className: "site", label: "Active Pharmacy *", missing: this.missing.siteId, options: this.availableOptions, onSelect: this.handleChangeSite, onInputChange: e => {
                                    util_1.pharmacyDropDownHandler({
                                        search: e,
                                        id: Number(this.siteId)
                                    });
                                }, searchable: true, value: this.siteId || "" })),
                        React.createElement("div", { className: "row" },
                            React.createElement(select_1.MaterialSelect, { className: "role", label: "Role *", disabled: disableHighlightedFields, missing: this.missing.groupId, options: this.availableGroups, onSelect: this.handleChangeGroup, value: this.groupId || "" }),
                            React.createElement("div", { className: "select phone" },
                                React.createElement("div", { className: "phone-ext" },
                                    React.createElement(text_field_1.MaterialTextField, { leftItem: React.createElement(icons_1.PhoneIcon, null), label: "Phone", disabled: disableHighlightedFields, onChange: this.handleChangeString("phone"), missing: isError, value: DataVal }),
                                    React.createElement(text_field_1.MaterialTextField, { className: "phone-ext--ext", label: "Ext", disabled: disableHighlightedFields, onChange: this.handleChangeString("phoneExt"), value: user.phoneExt || "" })),
                                React.createElement("p", { style: { color: 'red' } }, isError)),
                            this.user && this.createUserMode && (React.createElement(text_field_1.MaterialTextField, { className: "userEditPassword", newPasswordField: true, label: "New Password", missing: this.missing.password, onChange: this.handleChangeString("password"), type: "password", value: this.user.password })),
                            this.user && this.createUserMode && (React.createElement(text_field_1.MaterialTextField, { className: "userEditPassword", label: "Confirm Password", newPasswordField: true, missing: this.missing.confirmPassword, onChange: this.handleChangeString("confirmPassword"), type: "password", value: this.user.confirmPassword }))),
                        React.createElement("div", { className: "row" },
                            React.createElement(text_area_1.MaterialTextArea, { disabled: disableHighlightedFields, className: "notes", onChange: this.handleChangeString("notes"), placeholder: "Notes", value: `${user.notes}` || "" })),
                        React.createElement("div", { className: "row" },
                            React.createElement(select_1.MaterialSelect, { className: "site", label: "Homepage", disabled: disableHighlightedFields, options: this.homepageOptions, onSelect: this.handleChangeHomepage, onInputChange: this.handleHomepageInputChange, searchable: true, value: this.user.homepage || "" })),
                        React.createElement("div", { className: "row" }, store_5.usersStore.permissions.ReadPharmacies && (React.createElement(multi_select_1.UiMultiSelect, { className: "short-class", label: "Accessible Pharmacies", disabled: disableHighlightedFields, options: this.availableOptions, values: this.multiSelections, onChange: values => this.handleChangeMultiSelect(values) })))))),
            this.showConfirmationEditUserSave && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Save", cancelText: "Cancel", message: `Please confirm save. <br />Do you want to save the user?`, onCancel: () => (this.showConfirmationEditUserSave = false), onConfirm: this.handleSubmit, title: "Save confirmation" })),
            this.changePasswordModal && (React.createElement("form", { autoComplete: "off" },
                React.createElement(change_password_modal_1.ChangePasswordModal, { title: "Change Password", message: "Passwords must be 8 characters in length.", 
                    // The user that is currently operating the application
                    currentUser: this.user, 
                    // The Id of the user that is currently being Edited
                    editableUserId: this.props.userId, userCreation: this.createUserMode, cancelText: "Cancel", onConfirm: this.passwordConfirm, onCancel: this.handleChangePassword }))),
            this.assetModal ? (React.createElement(modal_1.AssetModal, { title: `Assets For ${this.user.firstName} ${this.user.lastName}`, width: "unset", maxWidth: "55%", maxHeight: "70%", top: "100px", onCancel: () => (this.assetModal = !this.assetModal) },
                React.createElement(asset_list_1.AssetList, { uploads: user.uploads, entityType: "user", entityData: this.user, onCredentialUpload: this.props.onCredentialUpload, onDeleteUpload: this.props.onDeleteUpload, onImageUpload: this.props.onImageUpload, onDescriptionSave: this.handleAssetsDescriptionsSave, onExpDateSave: this.handleAssetsExpDateSave, onConnectAssetSave: this.handleAssetsDescriptionsSave, onCancel: () => (this.assetModal = !this.assetModal) }))) : null,
            this.iframeUrl ? (React.createElement(iframe_preview_1.IFramePreview, { title: this.currentAssetViewing.fileOriginalName || "N/A", iframeUrl: this.iframeUrl, download: this.iframeUrl, onClose: this.handlePreviewClose })) : null,
            React.createElement(ReactTooltip, { effect: "solid", place: "left", delayShow: 300, "data-type": "info", multiline: true })));
    }
    get homepageOptions() {
        const { permissions } = store_5.usersStore;
        const { HomepageDashboard, HomepageClaims, HomepageInventories, HomepageOrder, HomepagePrescribe, HomepageLabels, HomepageDispense, HomepageReports, HomepageLedger, HomepageEob, HomepageAssetApprovals, HomepageFinancials } = permissions;
        const homepageOptions = {
            HomepageDashboard,
            HomepageClaims,
            HomepageInventories,
            HomepageOrder,
            HomepagePrescribe,
            HomepageLabels,
            HomepageDispense,
            HomepageReports,
            HomepageLedger,
            HomepageEob,
            HomepageAssetApprovals,
            HomepageFinancials
        };
        const availableHomepageOptions = Object.entries(homepageOptions)
            .filter(([key, value]) => value)
            .map(([key, value], index) => ({
            id: index,
            label: this.normalizeLabelHomepage(key),
            value: this.normalizeValueHomepage(key)
        }));
        return availableHomepageOptions;
    }
};
__decorate([
    mobx_1.computed
], EditUser.prototype, "availableOptions", null);
__decorate([
    mobx_1.computed
], EditUser.prototype, "availableGroups", null);
__decorate([
    mobx_1.observable
], EditUser.prototype, "user", void 0);
__decorate([
    mobx_1.observable
], EditUser.prototype, "siteId", void 0);
__decorate([
    mobx_1.observable
], EditUser.prototype, "groupId", void 0);
__decorate([
    mobx_1.observable
], EditUser.prototype, "createUserMode", void 0);
__decorate([
    mobx_1.observable
], EditUser.prototype, "changePasswordModal", void 0);
__decorate([
    mobx_1.observable
], EditUser.prototype, "multiSelections", void 0);
__decorate([
    mobx_1.observable
], EditUser.prototype, "iframeUrl", void 0);
__decorate([
    mobx_1.observable
], EditUser.prototype, "currentAssetViewing", void 0);
__decorate([
    mobx_1.observable
], EditUser.prototype, "missing", void 0);
__decorate([
    mobx_1.observable
], EditUser.prototype, "showConfirmationEditUserSave", void 0);
__decorate([
    mobx_1.observable
], EditUser.prototype, "assetModal", void 0);
__decorate([
    mobx_1.computed
], EditUser.prototype, "homepageOptions", null);
EditUser = __decorate([
    mobx_react_1.observer
], EditUser);
exports.EditUser = EditUser;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/users/modules/users-list/components/edit-user/edit-user.tsx
// module id = 4069
// module chunks = 0